import { WidgetsOnlineAddressMain } from '@/widgets/online-address';

export const PagesOnlineAddressMain = () => <WidgetsOnlineAddressMain />;
